import { ApiMethodKeys } from "@sso/constant";
import { AssignTrialLicenceResponse, PendingLicencePurchase, PurchaseLicenceRequest } from "@sso/types";

import { ssoApi } from "..";
import { CacheKeys } from "../cacheKeys";
import { Endpoints } from "../endpoints";

export const pendingLicencePurchaseApi = ssoApi
  .enhanceEndpoints({ addTagTypes: [CacheKeys.PENDING_LICENCE_PURCHASE] })
  .injectEndpoints({
    endpoints: builder => ({
      redeemPendingLicence: builder.query<PendingLicencePurchase, { pendingLicencePurchaseId: string; hash: string }>({
        query: ({ pendingLicencePurchaseId, hash }) => ({
          url: Endpoints.PENDING_LICENCE_PURCHASE,
          method: "GET",
          params: { pendingLicencePurchaseId, hash },
        }),
        providesTags: [CacheKeys.PENDING_LICENCE_PURCHASE],
      }),

      updatePendingLicenceCurrency: builder.mutation<
        void,
        { pendingLicencePurchaseId: string; hash: string; transactionCurrencyCode: string }
      >({
        query: ({ pendingLicencePurchaseId, hash, transactionCurrencyCode }) => ({
          url: Endpoints.PENDING_LICENCE_PURCHASE,
          method: "PUT",
          params: { pendingLicencePurchaseId, hash, transactionCurrencyCode },
        }),
        invalidatesTags: [CacheKeys.PENDING_LICENCE_PURCHASE],
      }),

      createPendingLicence: builder.mutation<
        { id: string; hash: string; transactionCurrencyCode: string },
        { currencyCode: string }
      >({
        query: ({ currencyCode }) => ({
          url: `${Endpoints.PENDING_LICENCE_PURCHASE}/Create/${currencyCode}`,
          method: "POST",
        }),
        invalidatesTags: [CacheKeys.PENDING_LICENCE_PURCHASE],
      }),

      assignTrialLicence: builder.mutation<
        AssignTrialLicenceResponse,
        { pendingLicencePurchaseId: string; hash: string; softwareLicenceId: string }
      >({
        query: ({ pendingLicencePurchaseId, hash, softwareLicenceId }) => ({
          url: `${Endpoints.PENDING_LICENCE_PURCHASE}/AssignTrialLicence`,
          method: "POST",
          params: { pendingLicencePurchaseId, hash, softwareLicenceId },
        }),
        invalidatesTags: [CacheKeys.PENDING_LICENCE_PURCHASE],
      }),
      purchaseSoftwareLicence: builder.mutation<string, PurchaseLicenceRequest>({
        query: data => ({ url: `${Endpoints.PENDING_LICENCE_PURCHASE}`, method: ApiMethodKeys.POST, data }),
      }),
    }),
  });

export const {
  useRedeemPendingLicenceQuery,
  useUpdatePendingLicenceCurrencyMutation,
  useCreatePendingLicenceMutation,
  useAssignTrialLicenceMutation,
  usePurchaseSoftwareLicenceMutation,
} = pendingLicencePurchaseApi;
